import React from "react";

import "./widget.css";

function Widget(props) {
  const {
    step = 1,
    changeStep,
    selectedBiller,
    selectedCategory,
    number,
  } = props;

  return (
    <>
      <div className="biller">
        <ol className="widget">
          <li className={step === 1 ? "active-step" : "visited-step"}>
            <div className="widget-panel">
              <div className="widget-heading">
                <h3 className="widget-title font-weight-bold">Step1</h3>
                <p className="font_26 text-dark">
                  {selectedCategory
                    ? selectedCategory
                    : "Select Biller Category"}
                </p>
              </div>
            </div>
            <div onClick={() => changeStep(1)}>
              <span
                className={
                  step === 1 ? "widget-badge active" : "widget-badge visited"
                }
              >
                <i className="material-icons text-white">done</i>
              </span>
            </div>
          </li>
          <li
            className={
              step === 2
                ? "active-step"
                : step > 2
                ? "visited-step"
                : "active-step"
            }
          >
            <div className="widget-panel">
              <div className="widget-heading">
                <h3 className="widget-title font-weight-bold text-primary">
                  Step2
                </h3>
                <p className={step >= 2 ? "font_26 text-dark" : "font-18"}>
                  {selectedBiller ? selectedBiller : "Select Biller Name"}
                </p>
              </div>
            </div>
            <div onClick={() => changeStep(2)}>
              <span
                className={
                  step > 2
                    ? "widget-badge visited"
                    : step < 2
                    ? "widget-badge disabled"
                    : "widget-badge active"
                }
              >
                {step >= 3 && <i className="material-icons text-white">done</i>}
              </span>
            </div>
          </li>
          <li
            className={
              step === 3
                ? "active-step"
                : step > 3
                ? "visited-step"
                : "active-step"
            }
          >
            <div className="widget-panel">
              <div className="widget-heading">
                <h3 className="widget-title text-muted font-weight-bold ">
                  Step3
                </h3>
                <p className={step >= 3 ? "font_26 text-dark" : "font-18"}>
                  {number ? number : "Add Details"}
                </p>
              </div>
            </div>
            <div onClick={() => changeStep(3)}>
              <span
                className={
                  step === 3
                    ? "widget-badge active"
                    : step < 3
                    ? "widget-badge disabled"
                    : "widget-badge visited"
                }
              >
                {step > 3 && <i className="material-icons text-white">done</i>}
              </span>
            </div>
          </li>
        </ol>
      </div>
    </>
  );
}

export default Widget;
